<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title class="grey1">{{ data.sysText.uploadDocumentTitle | titlecase }}</h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="cancel()" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <ng-container>
    <form [formGroup]="form">
      <input hidden type="file" #imgFileInput (change)="handleFileInput($event.target.files)" autocomplete="off"/>

      <div class="file-input-field">
        <mat-icon class="input-icon">attach_file</mat-icon>
        <button
          #uploadButton
          type="button"
          mat-stroked-button
          color="accent"
          (click)="imgFileInput.click()"
          class="button">
          <mat-icon>upload</mat-icon>
          <span>{{data.sysText.upload | capitalizefirst}}</span>
        </button>
        @if (fileToUpload) {
          <div class="pad">
            <div class="flex">
              <mat-icon class="fill4-dk check-padding">check</mat-icon>
              <div>
                <span class="body2 side-space grey3">{{ fileToUpload?.name }}</span>
              </div>
              <button type="button" class="button-reset" [attr.aria-label]="data.sysText.removeFile_ariaLabel" (click)="clearFile()">
                <mat-icon class="black-inactive small pointer">clear</mat-icon>
              </button>
            </div>
          </div>
        }
        <mat-error class="body2 upload-error" aria-live="polite">{{ document.errors?.msError}}</mat-error>
      </div>

      <app-input-field
        [group]="form"
        [control]="documentTitle"
        [icon]="'description'"
        [label]="data.sysText.documentTitle">
      </app-input-field>
      <app-select-field
        [group]="form"
        [control]="documentCategoryId"
        [options]="data.docUploadDialog.categories"
        [icon]="'list'"
        [label]="data.sysText.documentCategory"
        [shouldCapitalize]="false"
      ></app-select-field>
      @if (showDateReceived) {
        <app-date-field
          [control]="dateReceived"
          [label]="data.sysText.dateReceived"
          [icon]="'calendar_today'"
        ></app-date-field>
      }
      <app-text-area
        [control]="documentComments"
        [label]="data.sysText.documentComments"
        [icon]="'comment'">
      </app-text-area>

      @if (data.mode == docUploadMode.Employee) {
        <div class="select-container">
          <mat-icon [ngClass]="{ focus: select.focused }">assignment_turned_in</mat-icon>
          <mat-form-field color="accent">
            <mat-label>{{ data.sysText.associatedCase | titlecase }}</mat-label>
            <mat-select #select="matSelect" [formControl]="associatedCase" disableOptionCentering panelClass="dropDownSelect" panelWidth="fit-content">
              <mat-select-trigger>
                {{associatedCase.value}}
              </mat-select-trigger>
              @for (case of data.docUploadDialog.cases; track case) {
                <mat-option [value]="case.caseId">
                  <span>{{ case.caseId }}</span>
                  @if (case.leaveType) {
                    <span class="caption option-extras">{{ case.leaveType }}</span>
                  }
                  @if (case.startDate) {
                    <span class="caption option-extras">@if (case.leaveType) {
                      <span class="bullet-spacing">&bull;</span>
                    }{{ data.sysText.caseLeaveInfo_started | titlecase }} {{case.startDate | date}}</span>
                  }
                </mat-option>
              }
            </mat-select>
            @if (data.docUploadDialog.cases.length === 0) {
              <mat-hint>{{ data.sysText.noCases }}</mat-hint>
            }
          </mat-form-field>
        </div>
      }
    </form>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (data.docUploadDialog.showNotificationToggle) {
    <div class="slide-container">
      <app-slide-toggle
        [control]="form.controls.sendNotification"
        [isDisabled]="(isSubmitting$ | async)"
        [label]="data.sysText.uploadDocument_sendNotif">
      </app-slide-toggle>
    </div>
  }

  @let isSubmitting = isSubmitting$ | async;
  <div>
    @if (!(isMobile$ | async)) {
      <button
        mat-stroked-button
        class="button"
        color="accent"
        [disabled]="isSubmitting"
        (click)="cancel()">
        {{ data.sysText.cancel }}
      </button>
    }
    <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      disabledInteractive
      [showProgress]="isSubmitting"
      [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
      (click)="!isSubmitting && onSubmit()">
      {{ data.sysText.submit }}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>
  </div>
</mat-dialog-actions>